import { useCallback } from 'react'
import api from '../../lib/commons/api'
import {
  IGetProductBacklogByTeamUuid,
  IUpdateProductBacklog,
  ProductBacklogRepository,
  UpdateProductBacklogInput,
  UpdateProductBacklogOutput,
} from '../../applications/ports/productBacklogRepository'

export const useProductBacklogRepository = (): ProductBacklogRepository => {
  const getByTeamUuid = useCallback<IGetProductBacklogByTeamUuid>(
    async (teamUuid: string) => {
      const response = await api.functional.request(
        'GET',
        '/api/v1/projects/scrums/product_backlogs',
        {
          teamUuid,
        }
      )
      const productBacklog = response.json
      return productBacklog ?? undefined
    },
    []
  )
  const update = useCallback<IUpdateProductBacklog>(
    async (input: UpdateProductBacklogInput) => {
      const response = await api.functional.request(
        'PUT',
        '/api/v1/projects/scrums/product_backlogs',
        input
      )
      return response.json as UpdateProductBacklogOutput
    },
    []
  )
  return {
    getByTeamUuid,
    update,
  }
}
